module.exports = __webpack_public_path__ + "img/about-us.c0e32bdb.png";